/** @jsx jsx */
import { jsx, Box, Flex, Text, Image } from "theme-ui"
import React, { useEffect, useState } from "react"
import axios from "axios"
import jsonpAdapter from "axios-jsonp"

import Layout from "../../components/Layout"
import AboutText from "../../components/AboutText"
import cloudinaryHelper from "../../helpers/cloudinaryHelper"

const About = () => {
  const [about, setAboutData] = useState({
    aboutData: null,
    isLoading: true,
  })

  const id = "bzn-vBPQfZmCTC2V2Y_BpE6SPw"

  useEffect(() => {
    axios({
      url: `https://data.prod.gonation.com/profile/getname/?profile_id=${id}`,
      adapter: jsonpAdapter,
    }).then(res => {
      setAboutData({
        ...about,
        aboutData: res.data,
        isLoading: false,
      })
    })
  }, [])

  return (
    <Layout pageTitle="about">
      <Box
        sx={{
          height: ["auto", "100vh"],
          background: "white",
          // backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${cloudinaryHelper(
          //   'https://media.gonation.com/w_800/sites/mix-prime/danbury-about-hero.jpg',
          //   2000
          // )})`,
          paddingX: 4,
          paddingY: 3,
          pb: [5, 3],
        }}
      >
        <Flex
          sx={{
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              width: ["100%", "44%", "55%"],
              textAlign: "center",
              pt: [5, 0, 0],
              pb: [4, 0],
            }}
          >
            <Image
              alt={"About Mix Prime"}
              sx={{ maxWidth: "400px" }}
              src={cloudinaryHelper(
                "https://media.gonation.com/w_800/sites/mix-prime/danbury-about-1.jpg",
                900
              )}
            />
          </Box>
          <Box sx={{ flex: ["auto", 1, 1] }}>
            {/* <Text
              as='p'
              sx={{ fontSize: [2, 3], lineHeight: 2, color: 'white' }}>
              {about.isLoading ? '' : about.aboutData.desc}
            </Text> */}
            <AboutText location="Danbury" />
            <Flex sx={{ mt: 2 }}>
              <Box sx={{ marginRight: [2, 3, 4] }}>
                <Image
                  src="https://media.gonation.com/w_800/sites/mix-prime/award-1.png"
                  alt="restaurant award"
                  sx={{ maxWidth: "200px" }}
                />
              </Box>
              <Box>
                <Image
                  src="https://media.gonation.com/w_800/sites/mix-prime/award-2.png"
                  alt="restaurant award"
                  sx={{ maxWidth: "200px" }}
                />
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Layout>
  )
}

export default About
